const MODURL = "https://rishabhgold.com/api"

export default MODURL
